import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import Select from 'react-select';
import { customStylesSm, DropdownIndicator } from '~/Styles/reactSelectStyles';

var INDICES_OPCOES = [
  { value: 'IGPM', label: 'IGPM' },
  { value: 'INCC', label: 'INCC' },
  { value: 'IPCA', label: 'IPCA' },
  { value: 'TR', label: 'TR' },
];

var MASK_DATE_MMAA = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

// Subseção complementar de Condições Especiais. Contém os 3 campos exigidos
// pelo payload da venda real que não estavam no CondicoesEspeciaisCompleto:
//  - financiamento.avaliacao_bancaria
//  - financiamento.data_termino_construcao (MM/AAAA)
//  - saldo_correcao.indice_correcao
//
// Renderiza apenas quando há pelo menos um motivo ativo no Card pai
// (financiamento.isAtivo ou saldoCorrecao.isAtivo) — controle externo via prop visivel.
export default function CondicoesEspeciaisExtras(props) {
  var visivel = !!props.visivel;
  var temFinanciamento = !!props.temFinanciamento;
  var temSaldoCorrecao = !!props.temSaldoCorrecao;
  var avaliacaoBancaria = !!props.avaliacaoBancaria;
  var setAvaliacaoBancaria = props.setAvaliacaoBancaria;
  var dataTerminoConstrucao = props.dataTerminoConstrucao || '';
  var setDataTerminoConstrucao = props.setDataTerminoConstrucao;
  var indiceCorrecao = props.indiceCorrecao || null;
  var setIndiceCorrecao = props.setIndiceCorrecao;

  if (!visivel) return null;

  var indiceSelecionado = INDICES_OPCOES.find(function(o) { return o.value === indiceCorrecao; }) || null;

  return (
    <Card className="mb-2 border-info">
      <Card.Body className="py-2">
        <h6 className="mb-2 text-info">
          <strong>Campos adicionais (exigidos para gravação)</strong>
        </h6>

        {temFinanciamento && (
          <Row className="align-items-end">
            <Col md={4} xs={12}>
              <Form.Check
                type="checkbox"
                id="ce-extras-aval-bancaria"
                label={<small>Avaliação bancária</small>}
                checked={avaliacaoBancaria}
                onChange={function(e) { setAvaliacaoBancaria(e.target.checked); }}
                className="mb-2"
              />
            </Col>
            <Col md={4} xs={12}>
              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">Término construção (MM/AAAA)</Form.Label>
                <MaskedInput
                  className="form-control form-control-sm"
                  mask={MASK_DATE_MMAA}
                  value={dataTerminoConstrucao}
                  onChange={function(e) { setDataTerminoConstrucao(e.target.value); }}
                  placeholder="MM/AAAA"
                />
              </Form.Group>
            </Col>
          </Row>
        )}

        {temSaldoCorrecao && (
          <Row>
            <Col md={4} xs={12}>
              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">Índice de correção</Form.Label>
                <Select
                  placeholder="Selecione..."
                  options={INDICES_OPCOES}
                  value={indiceSelecionado}
                  onChange={function(opt) { setIndiceCorrecao(opt ? opt.value : null); }}
                  styles={customStylesSm}
                  components={{ DropdownIndicator: DropdownIndicator }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </Form.Group>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
}
